import ky from 'ky'

import { useAuth } from '@/libs/hooks/use-auth'

const kyApi = ky.create({
	headers: {
		'X-Platform': 'web',
		'X-Creator-Mail': 'rizqynugroho88@gmail.com',
	},
	hooks: {
		beforeRequest: [
			(req) => {
				const token = useAuth.getState().getCookieToken()
				if (token) {
					req.headers.set('Authorization', `Bearer ${token}`)
				}
			},
		],
	},
	retry: {
		methods: ['get'],
	},
})

export { kyApi }
